import { createSlice } from '@reduxjs/toolkit';

import eventBus, { EventType } from '@utils/eventBus';

import {
  handleAdminCreateNewProgramCode,
  handleAdminEditProgramCode,
  handleGetAdminProgramCodeDetails,
  handleGetAdminProgramCodes,
} from './actions';
import { IAdminProgramCodesState } from './slice.interface';

const initialState: IAdminProgramCodesState = {
  data: null,
  isLoading: false,
  error: false,
  programCodeId: null,
  programCode: null,
  programCodeIsLoading: false,
  programCodeError: false,
  isCreatingNew: false,
};

export const adminProgramCodesSlice = createSlice({
  name: 'adminProgramCodes',
  initialState,
  reducers: {
    removeAdminProgramCodeList: state => {
      state.data = null;
      state.isLoading = false;
      state.error = false;
    },
    removeAdminProgramCodeDetails: state => {
      state.programCodeId = null;
      state.programCode = null;
      state.programCodeIsLoading = false;
      state.programCodeError = false;
      state.isCreatingNew = false;
    },
    setAdminProgramCodeCreatingNew: state => {
      state.programCodeId = null;
      state.programCode = null;
      state.programCodeIsLoading = false;
      state.programCodeError = false;
      state.isCreatingNew = true;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetAdminProgramCodes.pending, (state: IAdminProgramCodesState) => {
        state.data = null;
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetAdminProgramCodes.rejected, (state: IAdminProgramCodesState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetAdminProgramCodes.fulfilled, (state: IAdminProgramCodesState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
      })
      .addCase(
        handleGetAdminProgramCodeDetails.pending,
        (state: IAdminProgramCodesState, action) => {
          state.programCodeId = action.meta.arg;
          state.programCodeIsLoading = true;
          state.programCodeError = false;
          state.isCreatingNew = false;
        },
      )
      .addCase(handleGetAdminProgramCodeDetails.rejected, (state: IAdminProgramCodesState) => {
        state.programCodeIsLoading = false;
        state.programCodeError = true;
      })
      .addCase(
        handleGetAdminProgramCodeDetails.fulfilled,
        (state: IAdminProgramCodesState, action) => {
          state.programCode = action.payload.data;
          state.programCodeIsLoading = false;
        },
      )
      .addCase(handleAdminCreateNewProgramCode.fulfilled, () => {
        eventBus.emit(EventType.ADMIN_CREATE_NEW_PROGRAM_CODE_SUCCESS);
      })
      .addCase(handleAdminEditProgramCode.fulfilled, () => {
        eventBus.emit(EventType.ADMIN_EDIT_PROGRAM_CODE_SUCCESS);
      });
  },
});

export const {
  removeAdminProgramCodeDetails,
  removeAdminProgramCodeList,
  setAdminProgramCodeCreatingNew,
} = adminProgramCodesSlice.actions;

export default adminProgramCodesSlice.reducer;
